// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

/* istanbul ignore file */
import {
  defineComponent,
  PageContainer,
  RiskVsReturnsGraph,
  SectionContainer,
} from '@shared/ui-kit';
import { useTraderBacktest } from '../hooks/use-trader-backtest';
import { MultiAsset } from '@shared/portfolio-analytics/components';
import { Toolbar } from '@shared/advisory/aggregation/components';

export const TraderBacktest = defineComponent({
  displayName: 'TraderBacktest',
  useSetup: useTraderBacktest,
  View: ({ analysis, backtest, kpis, returns, periodPicker, isLoading }) => {
    return (
      <PageContainer className="!mx-0 !px-0" loading={isLoading}>
        <div className="space-y-10">
          <Toolbar
            controls={['period']}
            onPeriodChange={periodPicker.onPeriodChange}
            onDateChange={periodPicker.onDateChange}
            availablePeriods={['YTD', '6M', '1Y', '3Y', '5Y', 'MAX']}
            defaultHist={periodPicker.defaultHist}
          />

          <MultiAsset
            feature="rebalance"
            kpis={kpis}
            returns={returns}
            analysis={analysis}
            backtest={backtest}
          />

          <SectionContainer testId="returns-tab-risk-returns">
            <RiskVsReturnsGraph risks={analysis?.risk_returns ?? []} />
          </SectionContainer>
        </div>
      </PageContainer>
    );
  },
});
